import { gql } from '@apollo/client';

export const GET_EMAIL_CAMPAIGN_ELIGIBLE_USERS = gql`
    query GetEmailCampaignEligibleUsers($data: EmailTargetingOptionsInput) {
        getEmailCampaignEligibleUsers(data: $data) {
            id
            email
            fullName
            planType
            createdAt
            lastActive
            engagementScore
            bounceStatus
            bounceCount
            lastEmailSent
        }
    }
`;

